module.exports = __webpack_public_path__ + "static/img/rank_347.0065703.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_347.png
// module id = 8HcK
// module chunks = 0